/* -----------------------------------------------------------------------------------------------------
  - Created: [29-01-2025] by [SREERAJ]
  - Modified: [13-06-2025] 
  - Description: This file contains Login Form
  -------------------------------------------------------------------------------------------------------
*/

import React, { useEffect, useState } from 'react'
import * as Yup from "yup";
import { useFormik } from 'formik';
import './loginPageStyle.css'
import LoginBgImg from '../../../Assets/LoginImages/loginBgImg.png'
import LogoImg from '../../../Assets/LoginImages/logo-techno.png'
import { VscEyeClosed } from "react-icons/vsc";
import { RxEyeOpen } from "react-icons/rx";
import { useNavigate } from 'react-router-dom';
import CustomTextFieldWithIcon from '../../../Components/custom_components/custom_text_field/CustomTextFieldWithIcon';
import { loginUser } from '../../../config/authApis';
import SpinnerWithLoader from '../../../Components/custom_components/SpinnerWithLoader/SpinnerWithLoader';
import { getAuthToken, saveAuthToken, saveUserData } from '../../../utils/localStorage';
import { ErrorToast, InfoToast, SuccessToast } from '../../../utils/toast';
import { IoMailSharp } from "react-icons/io5";
import { FaLock } from "react-icons/fa";
import Cookies from 'js-cookie';
import { CiLock } from 'react-icons/ci';
import { forgot_password, forgot_password_code_check, reset_password } from '../../../config/ForgotPassword/forgotPasswordApis';
import { APP_CONFIG } from '../../../config/appConfig';

function LoginPage() {

    const navigate = useNavigate()

    const [showPassword, setShowPassword] = useState(false)
    const [isButtonDisabled, setIsButtonDisabled] = useState(false); // State for button disabled
    const [rememberMe, setRememberMe] = useState(false);
    const [step, setStep] = useState(0); //0: login  1: email input, 2: code input 3: reset password

    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    // FOR GET TOKEN & USER CREDENTIALS FROM BROWSER STORAGE 
    useEffect(() => {

        const rememberedInfo = Cookies.get('rememberInfo');
        const token = getAuthToken();

        if (rememberedInfo) {
            const parsedData = JSON.parse(rememberedInfo);
            formik.setValues({ //FOR REMEMBER ME THE USER CREDENTIALS FROMTHE COOKIES
                username: parsedData?.username || '',
                password: parsedData?.password || '',
                LD_Source: parsedData?.LD_Source
            });
            setRememberMe(true);
        }
        if (token) navigate('/dashboard/dashboard/overview'); //IF TOKEN HAVE VALUE THE REDIRECT TO DASHBOARD
    }, []);

    //FOR HIDE AND SHOW PASSWORD
    const handlePasswordvisibale = () => {
        setShowPassword(!showPassword)
    }

    //FOR FORM SUBMITION
    const formik = useFormik({
        initialValues: {
            'username': '',
            'password': '',
            'LD_Source': 1 //FOR CHECK WEB OR MOBILE  (1 MEANS WEB)
        },
        validationSchema: Yup.object({
            username: Yup.string().required("Username is required"),
            password: Yup.string().required("Password is required"),
        }),

        onSubmit: async (values) => {
            try {
                setIsButtonDisabled(true)
                const formData = new FormData();
                for (const key in values) {
                    formData.append(key, values[key]);
                }

                const response = await loginUser(formData);
                if (response?.status === "success") {
                    saveAuthToken(response?.token)
                    saveUserData(response?.data)
                    setIsButtonDisabled(false)
                    // -----------FOR REMEMBER ME -------
                    if (rememberMe) {
                        const rememberInfo = {
                            username: formik.values.username,
                            password: formik.values.password,
                            LD_Source: 1
                        }
                        Cookies.set('rememberInfo', JSON.stringify(rememberInfo), { expires: 30 });
                    } else {
                        Cookies.remove('rememberInfo');
                    }
                    SuccessToast(response?.message);
                    //   -------------------------------
                    navigate('/dashboard/dashboard/overview');
                }
            } catch (error) {
                //MODIFIED BY SREERAJ 5/5/25 
                // error handled in api config file

            } finally {
                setIsButtonDisabled(false)
            }
        }
    });

    // Forgot Password Formik
    const forgotFormik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string()
                .matches(
                    /^[a-zA-Z0-9]+([._+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                    'Invalid email format'
                )
                .required('Email is required'),
        }),

        onSubmit: async (values) => {
            try {
                setIsButtonDisabled(true);
                const response = await forgot_password(values);
                if (response?.status === "success") {
                    SuccessToast(response?.message);
                    setStep(2)
                } else {
                    SuccessToast(response?.message);
                }

            } catch (err) {
                console.log("err", err);
            } finally {
                setIsButtonDisabled(false);
            }
        }
    });

    // CODE Formik
    const codeFormik = useFormik({
        initialValues: {
            code: '',
        },
        validationSchema: Yup.object({
            code: Yup.string()
                .required('Code is required')
                .max(10, 'Code must not exceed 10')
                .matches(/^[0-9]+$/, 'Only numbers are allowed'),
        }),
        onSubmit: async (values) => {
            try {
                setIsButtonDisabled(true);
                const response = await forgot_password_code_check(values);
                if (response?.status === "success") {
                    resetPasswordFormik.setFieldValue('code', response?.code);
                    SuccessToast(response?.message);
                    setStep(3)
                } else {
                    SuccessToast(response?.message);
                }

            } catch (err) {
                console.log("err", err);
            } finally {
                setIsButtonDisabled(false);
            }
        }
    });

    // RESET PASSWORD  Formik
    const resetPasswordFormik = useFormik({
        initialValues: {
            code: '',
            password: '',
            password_confirmation: '',
        },
        validationSchema: Yup.object({
            code: Yup.string()
                .required('Reset Code is required'),

            password: Yup.string()
                .required('New Password is required')
                .min(8, 'Password must be at least 8 characters long')
                .max(20, 'Password must not exceed 20 characters')
                .matches(/[a-z]/, 'Must contain at least one lowercase letter')
                .matches(/[A-Z]/, 'Must contain at least one uppercase letter')
                .matches(/[0-9]/, 'Must contain at least one digit')
                .matches(/[@$!%*#?&]/, 'Must contain at least one special character'),

            password_confirmation: Yup.string()
                .required('Confirm Password is required')
                .oneOf([Yup.ref('password'), null], 'Passwords must match'),
        }),
        onSubmit: async (values) => {
            const params = {
                code: values.code,
                password: values.password,
                password_confirmation: values.password_confirmation,
            };
            try {
                setIsButtonDisabled(true);
                const response = await reset_password(params);
                if (response?.status === 'success') {
                    SuccessToast(response?.message);
                    setStep(0)
                } else {
                    ErrorToast(response?.message || 'Failed to reset password');
                }
            } catch (error) {
                console.log("error", error);
            } finally {
                setIsButtonDisabled(false);
            }
        },
    });


    useEffect(() => {
        if (step === 0) { //clear the touched & errors by sreeraj 13-6-25
            forgotFormik.resetForm();
            codeFormik.resetForm();
        }
    }, [step])
    const [imageLoaded, setImageLoaded] = useState(false);

    useEffect(() => {
        // Preload the background image
        const img = new Image();
        img.src = LogoImg;
        img.onload = () => setImageLoaded(true);
    }, []);
    return (
        <div className="loginPage-main-container">
            <div className="">
                <div className="login-bubble-bg-8291">
                    <div className="login-bubble-2840"></div>
                    <div className="login-bubble-2840"></div>
                    <div className="login-bubble-2840"></div>
                    <div className="login-bubble-2840"></div>
                </div>

                <div className="login-bubble-bg-8291">
                    <div className="login-bubble-2840"></div>
                    <div className="login-bubble-2840"></div>
                    <div className="login-bubble-2840"></div>
                    <div className="login-bubble-2840"></div>
                </div>
            </div>
            {/* BUBBLES */}



            {/* Heder */}
            <div className="loginPage-header-container">
                <div className="loginPage-header">
                    <img src={APP_CONFIG.APP_LOGO_GREY_TXT} alt="App Logo" className="loginPage-logo" />
                </div>
                <div className="loginPage-header">
                    <img src={LogoImg} alt="App Logo" className="loginPage-logo" />
                </div>
            </div>
            <div
                className="loginPage-content"
                style={{ opacity: imageLoaded ? 1 : 0, transition: "opacity 1s ease-in-out" }}
            >
                {/* RIGHT SIDE */}
                <div className="loginPage-right-side">
                    <div className="loginPage-box-wrapper">
                        <div className="loginPage-box">
                            {/* TITLE */}
                            <div className="loginPage-top-section">
                                <div>
                                    <span className="loginPage-greeting">Welcome to </span>
                                    <span className="loginPage-company">{APP_CONFIG?.APP_NAME}</span>
                                </div>
                                {/* <div className="loginPage-header">
                        <img src={APP_CONFIG.APP_LOGO} alt="App Logo" className="loginPage-logo" />
                    </div>  */}
                                <div className="loginPage-desc">
                                    <span className="loginPage-tagline">{APP_CONFIG.TAG_LINE}</span>
                                </div>
                            </div>

                            {/* LOGIN STEP */}
                            {step === 0 && (
                                <form id="LoginPage" onSubmit={formik.handleSubmit}>
                                    <div className="loginPage-label">
                                        <span className="loginPage-label-text">
                                            Username<span className="loginPage-required">*</span>
                                        </span>
                                    </div>
                                    <div className="loginPage-input-container">
                                        <CustomTextFieldWithIcon
                                            id="username"
                                            name="username"
                                            placeholder="Enter your username"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.username}
                                            error={formik.touched.username && Boolean(formik.errors.username)}
                                            helperText={formik.touched.username && formik.errors.username}
                                            StartIcon={IoMailSharp}
                                        />
                                    </div>

                                    <div className="loginPage-label">
                                        <span className="loginPage-label-text">
                                            Password<span className="loginPage-required">*</span>
                                        </span>
                                    </div>
                                    <div className="loginPage-input-container">
                                        <CustomTextFieldWithIcon
                                            id="password"
                                            name="password"
                                            type={showPassword ? 'text' : 'password'}
                                            placeholder="Enter your password"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.password}
                                            error={formik.touched.password && Boolean(formik.errors.password)}
                                            helperText={formik.touched.password && formik.errors.password}
                                            StartIcon={FaLock}
                                            EndIcon={showPassword ? RxEyeOpen : VscEyeClosed}
                                            onEndIconClick={handlePasswordvisibale}
                                        />
                                    </div>

                                    <div className="loginPage-remember-forgot">
                                        <label>
                                            <input
                                                type="checkbox"
                                                checked={rememberMe}
                                                className="loginPage-remember-checkbox"
                                                onChange={(e) => setRememberMe(e.target.checked)}
                                            />{" "}
                                            Remember Me
                                        </label>
                                        <span onClick={() => setStep(1)} className="loginPage-forgot-link">
                                            Forgot Password?
                                        </span>
                                    </div>

                                    <button
                                        className="loginPage-btn  mt-5"
                                        type="submit"
                                        form="LoginPage"
                                        disabled={isButtonDisabled}
                                    >
                                        <div className="loginPage-btn-inner">
                                            <span className="loginPage-btn-text">Log In</span>
                                            {isButtonDisabled && (
                                                <SpinnerWithLoader spinnerType="border" size="sm" text="" />
                                            )}
                                        </div>
                                    </button>
                                </form>
                            )}

                            {/* FORGOT PASSWORD STEP */}
                            {step === 1 && (
                                <form onSubmit={forgotFormik.handleSubmit}>
                                    <div className="loginPage-label">
                                        <span className="loginPage-label-text">
                                            Email<span className="loginPage-required">*</span>
                                        </span>
                                    </div>
                                    <div className="loginPage-input-container">
                                        <CustomTextFieldWithIcon
                                            id="email"
                                            name="email"
                                            placeholder="Enter your registered email"
                                            onChange={forgotFormik.handleChange}
                                            onBlur={forgotFormik.handleBlur}
                                            value={forgotFormik.values.email}
                                            error={forgotFormik.touched.email && Boolean(forgotFormik.errors.email)}
                                            helperText={forgotFormik.touched.email && forgotFormik.errors.email}
                                            StartIcon={IoMailSharp}
                                        />
                                    </div>

                                    <button className="loginPage-btn mt-5" type="submit" disabled={isButtonDisabled}>
                                        <div className="loginPage-btn-inner">
                                            <span className="loginPage-btn-text">Send</span>
                                            {isButtonDisabled && (
                                                <SpinnerWithLoader spinnerType="border" size="sm" text="" />
                                            )}
                                        </div>
                                    </button>

                                    <div className="loginPage-footer-links">
                                        <span onClick={() => setStep(0)} className="loginPage-link">
                                            Back to Login
                                        </span>
                                        <span onClick={() => setStep(2)} className="loginPage-link">
                                            Already Have Code
                                        </span>
                                    </div>
                                </form>
                            )}

                            {/* ENTER CODE STEP */}
                            {step === 2 && (
                                <form onSubmit={codeFormik.handleSubmit}>
                                    <div className="loginPage-label">
                                        <span className="loginPage-label-text">
                                            Enter Code<span className="loginPage-required">*</span>
                                        </span>
                                    </div>
                                    <div className="loginPage-input-container">
                                        <CustomTextFieldWithIcon
                                            id="code"
                                            name="code"
                                            placeholder="Enter the code"
                                            onChange={codeFormik.handleChange}
                                            onBlur={codeFormik.handleBlur}
                                            value={codeFormik.values.code}
                                            StartIcon={CiLock}
                                            error={codeFormik.touched.code && Boolean(codeFormik.errors.code)}
                                            helperText={codeFormik.touched.code && codeFormik.errors.code}
                                        />
                                    </div>

                                    <button className="loginPage-btn mt-2" type="submit" disabled={isButtonDisabled}>
                                        <div className="loginPage-btn-inner">
                                            <span className="loginPage-btn-text">Submit Code</span>
                                            {isButtonDisabled && (
                                                <SpinnerWithLoader spinnerType="border" size="sm" text="" />
                                            )}
                                        </div>
                                    </button>

                                    <div className="loginPage-footer-links">
                                        <span onClick={() => setStep(0)} className="loginPage-link">
                                            Back to Login
                                        </span>
                                    </div>
                                </form>
                            )}

                            {/* RESET PASSWORD STEP */}
                            {step === 3 && (
                                <form id="resetPasswordFormik" onSubmit={resetPasswordFormik.handleSubmit}>
                                    <div className="loginPage-label">
                                        <span className="loginPage-label-text">
                                            Reset Code<span className="loginPage-required">*</span>
                                        </span>
                                    </div>
                                    <div className="loginPage-input-container">
                                        <CustomTextFieldWithIcon
                                            type="text"
                                            id="code"
                                            name="code"
                                            placeholder="Enter the reset code"
                                            onChange={resetPasswordFormik.handleChange}
                                            onBlur={resetPasswordFormik.handleBlur}
                                            value={resetPasswordFormik.values.code}
                                            StartIcon={CiLock}
                                            error={resetPasswordFormik.touched.code && Boolean(resetPasswordFormik.errors.code)}
                                            helperText={resetPasswordFormik.touched.code && resetPasswordFormik.errors.code}
                                        />
                                    </div>

                                    <div className="loginPage-label">
                                        <span className="loginPage-label-text">
                                            New Password<span className="loginPage-required">*</span>
                                        </span>
                                    </div>
                                    <div className="loginPage-input-container">
                                        <CustomTextFieldWithIcon
                                            type={showNewPassword ? 'text' : 'password'}
                                            id="password"
                                            name="password"
                                            placeholder="Enter your new password"
                                            onChange={resetPasswordFormik.handleChange}
                                            onBlur={resetPasswordFormik.handleBlur}
                                            value={resetPasswordFormik.values.password}
                                            StartIcon={CiLock}
                                            EndIcon={showNewPassword ? RxEyeOpen : VscEyeClosed}
                                            onEndIconClick={() => setShowNewPassword(!showNewPassword)}
                                            error={resetPasswordFormik.touched.password && Boolean(resetPasswordFormik.errors.password)}
                                            helperText={resetPasswordFormik.touched.password && resetPasswordFormik.errors.password}
                                        />
                                    </div>

                                    <div className="loginPage-label">
                                        <span className="loginPage-label-text">
                                            Confirm Password<span className="loginPage-required">*</span>
                                        </span>
                                    </div>
                                    <div className="loginPage-input-container">
                                        <CustomTextFieldWithIcon
                                            type={showConfirmPassword ? 'text' : 'password'}
                                            id="password_confirmation"
                                            name="password_confirmation"
                                            placeholder="Confirm your new password"
                                            onChange={resetPasswordFormik.handleChange}
                                            onBlur={resetPasswordFormik.handleBlur}
                                            value={resetPasswordFormik.values.password_confirmation}
                                            StartIcon={CiLock}
                                            EndIcon={showConfirmPassword ? RxEyeOpen : VscEyeClosed}
                                            onEndIconClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                            error={
                                                resetPasswordFormik.touched.password_confirmation &&
                                                Boolean(resetPasswordFormik.errors.password_confirmation)
                                            }
                                            helperText={
                                                resetPasswordFormik.touched.password_confirmation &&
                                                resetPasswordFormik.errors.password_confirmation
                                            }
                                        />
                                    </div>

                                    <button className="loginPage-btn mt-2" type="submit" disabled={isButtonDisabled}>
                                        <div className="loginPage-btn-inner">
                                            <span className="loginPage-btn-text">Save</span>
                                            {isButtonDisabled && (
                                                <SpinnerWithLoader spinnerType="border" size="sm" text="" />
                                            )}
                                        </div>
                                    </button>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default LoginPage